// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SqkL","col":"styles_col__1sPZt","actions":"styles_actions__JDDaa","conflict":"styles_conflict__Dna3o"};